import { VersionInfo } from "./version-info";
import { SiLinkedin } from "react-icons/si";

export function Footer() {
  return (
    <footer className="border-t py-4 px-4 md:px-6">
      <div className="container flex flex-col sm:flex-row items-center justify-between">
        <div className="text-sm text-muted-foreground text-center sm:text-left mb-2 sm:mb-0 whitespace-nowrap">
          &copy; {new Date().getFullYear()} SAASGAMA. All rights reserved.
        </div>
        <div className="flex items-center space-x-4">
          {/* Social Media Links */}
          <div className="flex items-center space-x-3 mr-4">
            <a
              href="https://www.linkedin.com/company/saasgama/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-blue-700 transition-colors"
              aria-label="Follow SAASGAMA on LinkedIn"
            >
              <SiLinkedin className="w-4 h-4" />
            </a>
          </div>
          <VersionInfo />
        </div>
      </div>
    </footer>
  );
}
